<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-07 16:08:23
 * @LastEditTime : 2020-01-20 13:59:38
 * @LastEditors  : Please set LastEditors
 -->
<template>
  <div class="new_center_container">
    <div class="header">
      <p class="title download-cn">下载中心</p>
      <p class="title download-en">DOWNLOAD</p>
      <div class="tabs">
        <el-tabs v-model="tabActiveId">
          <el-tab-pane v-for="item in tabs" :key="item.v" :label="item.k" :name="item.v" />
        </el-tabs>
      </div>
      <div class="download-list-container">
        <ul class="list">
          <li v-for="(item, index) in data[+tabActiveId].list" class="item" :key="index">
            <img :src="item.pic" alt class="logo" />
            <p class="item-title">{{ item.title }}</p>
            <p class="subtitle">{{ item.des }}</p>
            <div class="qr-box" v-if="item.type === 1">
              <div v-for="(v, i) in item.code" :key="i">
                <img :src="v.url" alt class="code" />
                <p class="des">{{ v.platform }}</p>
              </div>
            </div>
            <div class="download-box" v-else>
              <a
                class="download-btn"
                v-for="(v, i) in item.code"
                :key="i"
                :href="v.needLoad ? urlFormatter(v.needLoad) : v.url"
                target="_blank"
              >
                <img
                  src="../../../public/img/mac_icon.png"
                  v-if="v.platformId ===4"
                  class="mac-icon"
                  alt
                />
                <img src="../../../public/img/win_icon.png" v-else class="win-icon" alt />
                {{ v.platform }}
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { list } from './assets/data'
import BackTop from '@/components/backTop/index'
export default {
  components: { BackTop },
  data () {
    return {
      data: list,
      key: 'value',
      classSystemLink: '#',
      videoLink: '#',
      chromeLink: '#',
      AILink: '#',
      aiBoardLink: '#',
      macBoardLink: '#',
      randomNum: 0,
      tabActiveId: '0',
      tabs: [
        {
          k: '家长/学生端',
          v: '0'
        },
        {
          k: '机构老师端',
          v: '1'
        },
        {
          k: '机构教室端',
          v: '2'
        }
      ],
      liveCloudStudentPath: '', // 直播云·学生PC端
      liveCloudTeacherPath: '' // 直播云·老师PC端
    }
  },
  created () {
    this.randomNum = Math.random() * 1000
    this.getPath()
    this.getclassSystemLink()
    this.getAiLink()
    this.getvideoLink()
    this.getchromeLink()
    this.getBoardLink()
  },
  methods: {
    urlFormatter (k) {
      return this[k]
    },
    // 获取直播云客户端的地址
    getPath () {
      let $this = this
      this.$axios
        .get(`https://fe-cdn.mofaxiao.com//cactus-official/client/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.liveCloudStudentPath = response.data.liveCloudStudentPath
          $this.liveCloudTeacherPath = response.data.liveCloudTeacherPath
        })
        .catch(error => {
          console.log(error)
        })
    },
    getclassSystemLink () {
      let $this = this
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/student/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.classSystemLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/student/${response.data.path}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getAiLink () {
      let $this = this
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/AI/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.AILink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/AI/${response.data.path}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getvideoLink () {
      let $this = this
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/vdyoo/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.videoLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/vdyoo/${response.data.path}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getchromeLink () {
      let $this = this
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/chrome/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.chromeLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/chrome/${response.data.path}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getBoardLink () {
      let $this = this
      let agent = navigator.userAgent.toLowerCase()
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0 || isMac) {
        this.$axios
          .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard64/latest.json?time=${Date.now()}`)
          .then(response => {
            $this.aiBoardLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard64/${response.data.path}`
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.$axios
          .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard/latest.json?time=${Date.now()}`)
          .then(response => {
            $this.aiBoardLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard/${response.data.path}`
          })
          .catch(error => {
            console.log(error)
          })
      }
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard-mac/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.macBoardLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard-mac/${response.data.path}`
          console.log($this.macBoardLink)
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  computed: {
    name () {
      return this.key
    }
  }
}
</script>

<style scoped lang="scss">
.new_center_container {
  margin: 80px auto 0 auto;
  width: 1280px;
  height: 660px;
  ul {
    padding-left: 0;
  }
  .header {
    position: relative;
    height: 420px;
    background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/download_bg.png')
      no-repeat center center;
    background-size: 1280px 420px;
    .title {
      position: absolute;
      left: 80px;
      &.download-cn {
        top: 40px;
        font-size: 40px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 56px;
      }
      &.download-en {
        top: 76px;
        font-size: 56px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 78px;
        opacity: 0.1;
      }
    }
    .tabs {
      position: absolute;
      top: 160px;
      left: 70px;
      width: 1106px;
      ::v-deep .el-tabs__item {
        margin-bottom: 20px;
        padding: 0 30px;
        height: 30px;
        font-size: 22px;
        line-height: 30px;
        color: rgba(255, 255, 255, 0.5);
      }
      ::v-deep .is-active {
        color: #ffffff;
      }
      ::v-deep .el-tabs__active-bar {
        background-color: #ffffff;
        height: 4px;
        border-radius: 2px;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 4px;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 49%,
          rgba(255, 255, 255, 0) 100%
        );
        opacity: 0.4;
      }
      ::v-deep .el-tabs__nav {
        margin-left: 320px;
      }
    }
    .download-list-container {
      position: absolute;
      top: 250px;
      width: 100%;
      img {
        width: 80px;
        height: 80px;
        &.logo {
          border-radius: 14px;
        }
      }
      .list {
        justify-content: center;
        display: flex;
        .item {
          margin: 0 8px;
          width: 264px;
          height: 366px;
          padding: 40px 38px 37px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 0 10px 0 rgba(81, 85, 105, 0.22);
          border-radius: 10px;
        }
        .logo {
          margin: 0 auto;
        }
        .item-title {
          margin: 20px 0 8px;
          font-weight: 600;
          color: rgba(40, 40, 40, 1);
          line-height: 22px;
        }
        .subtitle {
          margin-bottom: 30px;
          font-size: 14px;
          font-weight: 300;
          color: rgba(40, 40, 40, 1);
          line-height: 20px;
        }
        .qr-box {
          text-align: center;
          display: flex;
          justify-content: center;
          img {
            margin: 0 15px;
          }
          .des {
            margin-top: 9px;
            font-size: 14px;
            font-weight: 300;
            color: rgba(40, 40, 40, 1);
            line-height: 20px;
          }
        }
        .download-box {
          padding-top: 10px;
          .download-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 188px;
            height: 36px;
            font-size: 14px;
            color: rgba(248, 248, 248, 1);
            line-height: 36px;
            background: rgba(251, 89, 74, 1);
            border-radius: 5px;
            text-align: center;
            cursor: pointer;
            &:first-child {
              margin-bottom: 10px;
            }
            .mac-icon {
              width: 20px;
              height: 20px;
              margin-right: 4px;
            }
            .win-icon {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}
</style>
